import babelpolyfill from 'babel-polyfill'
import Vue from 'vue';
import http from './api/http';
import store from './store/index';
import router from './router/index';
import VueRouter from 'vue-router';
import App from './App.vue';
import moment from 'moment';
moment.locale('zh-cn');

import mUtils from './utils/mUtils';
import {apiConfig} from './config/apiConfig';

// 引入公共样式表
import './assets/css/themePc.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


//RSA加密
import JSEncrypt from 'jsencrypt';

Vue.prototype.$moment = moment;

Vue.prototype.$getRsaCode = function(str){ // 注册方法
  let pubKey = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsc6c2cD/quMou7EihUxN
  W6SAYSrjGOXQb5vMYZF6TT0FWa0J6s2rJQbOkcxS6BdFiSvP7rqqlU24dw/kwbOY
  Etkir+jRwrBdoMG1ZncHrOT8DBFNngfGeC0hp5H0L5JiQF/lLeYzBIUSJ1eZwwoI
  TqeA8XhKc6/huxsVDDKnc6q1Zc+6w3IayMTQSqY2vkx45FO8jDggVJomxy/KjeBO
  lazYe3f74HKqRkp+SA7CSFzJx9q06m7eAuIr5Myfzlf+0F4i3BfeXr9pnXWGdS80
  bBBY3r3uWqV1f3CJVGa0GtMTxDvJatS4LJhJQl8FEwU8W24mrll6zz/ZhtZIe4Iw
  qwIDAQAB
  -----END PUBLIC KEY-----`;
  // ES6 模板字符串 引用 rsa 公钥
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let  data = encryptStr.encrypt(str.toString());  // 进行加密
  return data;
}

Vue.prototype.$decryptRsaCode = function(str){ // 注册方法
  let pubKey = `-----BEGIN RSA PRIVATE KEY-----
  MIIEogIBAAKCAQEAsc6c2cD/quMou7EihUxNW6SAYSrjGOXQb5vMYZF6TT0FWa0J
  6s2rJQbOkcxS6BdFiSvP7rqqlU24dw/kwbOYEtkir+jRwrBdoMG1ZncHrOT8DBFN
  ngfGeC0hp5H0L5JiQF/lLeYzBIUSJ1eZwwoITqeA8XhKc6/huxsVDDKnc6q1Zc+6
  w3IayMTQSqY2vkx45FO8jDggVJomxy/KjeBOlazYe3f74HKqRkp+SA7CSFzJx9q0
  6m7eAuIr5Myfzlf+0F4i3BfeXr9pnXWGdS80bBBY3r3uWqV1f3CJVGa0GtMTxDvJ
  atS4LJhJQl8FEwU8W24mrll6zz/ZhtZIe4IwqwIDAQABAoIBACZD6M2UE3GbYXDD
  NkKpoRxP0rEWobkB/FGInfuBa2ij8TrTWocFrAdT57DI4C7Ck1xp6V3fHkbzavd0
  nC5zkA6+XBCvcjUL75phFcDvbN9wiC2wq5uO4M+MJuoBJyP1xN9Fw/SUzfXzDW0a
  FSU8S31h3wYYdS1gdJvnwCfX3uGtR0bgl1Qb+ccF9Oyu4klymo5xQSWn2BFMTFWb
  0dKGz7sbXw7rMNj41qCLFnhs54zYmHGsMRm9rXhiJ9kviwgGd5o61AhPUApPc9W7
  Z/68lO30R0F2ocLBwvw5Sg5EZwYqcQi2W1R3xJRcsyDe68LJaDS8OyDulCCa6WNM
  RroSowECgYEA45iInOJjdCgzK/7LOidiywbRl+ZNCEGi5fKTs+dQ3qOmXC/w8FPw
  BCi4ibmwsDedRiTG1cccMlPTbbgCRgQyuBPe2Xx3N2Nbw1DxmiBbQ/7q3NvY2g+Z
  SmlQ6cZMjCDShg/P3YYMoMsK8HRrhVqu9OOzZZ/KmqihZiZGlGy+L1ECgYEAx/9g
  alFjMyIZMYjrH5QQqswDrN9B0u9PlQQW8achLyX0AUNa6Ar0f5xOBCy6Idx4jqGv
  xg3/6r0mQx+7m7ixjZWuzQT1KAqlK/DCHO/Tb99B2bX5NFvT3nQj3ZEIx82Kzh6U
  NzRxrJQ0x6Q9U0F2wFBMQQkniqODskjKL15QeTsCgYAXfzHrcHvwDA5sZlu430QV
  zdhppD8jsRMORmL1WdZBhgew0MpBJYlMBKA4p9EUAEneagGVJH9GutzDIRIrBFfw
  JS0GqxDryPg6S+sFjH2foXvB3Xif2qhqxEC0QeK5PNI/QPam2iYHm66/cGWBWQFj
  CvcEcODL4sj28NCsliV0YQKBgHH5UxTDtOia8giMopGoa6cqBJ4rzPNMdenSHtEw
  EXUxB9EAdXnvZE6k4MD4TEqnvfxqoCUaLVG04W03VE71/hlVx/wGaz+acW6NEdIz
  yibi8EAFuDLicedAAIBv+rUCqau1OXoMZQuYmkt7iYc8s1P9brdRZDtZ299qI+7C
  rNGpAoGAQcwQ713/XLLoZf5/gRsGHVr3/GjI9r+s97u5OeCYRUjQvPAfN4B4byzJ
  gFWFUfEDL7PB7JdfP4A49ZGz/mdmxxwyPYX/9c5WfJ62RY2lYCtgiMxC6F3i+MR/
  vnyBjWXys6I0+H+J4CmoSgDxKcCbZhiA36iTY2XSw+HpL0Hjqiw=
  -----END RSA PRIVATE KEY-----`;
  // ES6 模板字符串 引用 rsa 公钥
  let decrypt = new JSEncrypt();
  decrypt.setPrivateKey(pubKey); // 设置 加密公钥
  let  data = decrypt.decrypt(str.toString());  // 进行加密
  return data;
}



// 引入echarts主模块（基础模块）
import ECharts from 'vue-echarts/components/ECharts.vue'

// 引入需要的echarts如表
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/pie';

// 引入需要的 echarts的交互组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import 'echarts/lib/component/visualMap';
import 'echarts/lib/component/toolbox';

import 'src/assets/styles/variable.scss';
import 'src/assets/styles/base.scss';
import 'src/assets/styles/common.scss';
import 'src/assets/styles/iconfont.css';


// 解决跳转到本页面报错的问题
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(ElementUI);

Vue.component('chart', ECharts);

Vue.config.productionTip = false;

Vue.prototype.$mUtils = mUtils;
Vue.prototype.$apiConfig = apiConfig;



/* eslint-disable no-new */

// 将axios挂载到prototype上，在组件中可以直接使用this.axios访问
Vue.prototype.axios = http;

new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
});

// IE兼容
if (
  '-ms-scroll-limit' in document.documentElement.style &&
  '-ms-ime-align' in document.documentElement.style
) { // detect it's IE11
  window.addEventListener("hashchange", function (event) {
    var currentPath = window.location.hash.slice(1);
    if (store.state.route.path !== currentPath) {
      router.push(currentPath)
    }
  }, false)
}



// WEBPACK FOOTER //
// ./src/main.js